import axios from '../api';
import store from '../store';
import Constants from './../constants';

export default {
  namespaced: true,

  state: {
    listModulesPages: [],

    infosPage: {
      id_page: 1,
      libelle_page: '',
      name_page: '',
    },

    infosPass: {
      id_pass: '',
      name: '',
    },

    neopassDatas: {},
    listEvaluations: [],

    loading: false,
    messageHeader: '',
  },

  getters: {
    listModulesPages(state) {
      return state.listModulesPages;
    },

    infosPage(state) {
      return state.infosPage;
    },

    infosPass(state) {
      return state.infosPass;
    },

    neopassDatas(state) {
      return state.neopassDatas;
    },

    listEvaluations(state) {
      return state.listEvaluations;
    },

    loading(state) {
      return state.loading;
    },

    messageHeader(state) {
      return state.messageHeader;
    },
  },

  mutations: {
    SET_LISTMODULESPAGES(state, modules) {
      state.listModulesPages = modules;
    },
    SET_INFOSPAGE(state, infos) {
      state.infosPage = infos;
    },
    SET_INFOSPASS(state, infos) {
      state.infosPass = infos;
    },
    SET_NEOPASSDATAS(state, datas) {
      state.neopassDatas = datas;
    },
    SET_LISTEVALUATIONS(state, evaluations) {
      state.listEvaluations = evaluations;
    },
    SET_LOADING(state, loadornot) {
      state.loading = loadornot;
    },
    SET_MESSAGEHEADER(state, progress) {
      state.messageHeader = progress;
    },
  },

  actions: {
    async loadModulesPages(context, id) {
      console.log('wait...loadModulesPages');
      await axios
        .get(
          '/api/modules/getModulesPages/cartographiesIndividuelle/' +
                        id
        )
        .then((response) => {
          context.commit('SET_LISTMODULESPAGES', response.data);
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async load_infos_pass(context, id) {
      await axios
        .get('/api/users/' + id)
        .then((response) => {
          console.log('wait...load_infos_pass');
          if (response.data == -1) {
            this.$router.push('/not-allowed');
          } else {
            /* Load datas for the form */
            let name =
                            response.data.firstname +
                            ' ' +
                            response.data.lastname;
            let infos = {
              id_pass: id,
              name: name,
            };
            context.commit('SET_INFOSPASS', infos);
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async update_infos_page(context, infos_page) {
      console.log('wait...update_infos_page');

      await axios
        .get('/api/modules/getModulesPages/neopass/0')
        .then((response) => {
          var list = response.data;
          let page_selected = context.getters.listModulesPages.filter(
            (p) => p.name == infos_page[1]
          )[0];

          let modPassName = '';

          switch (page_selected.name) {
          case Constants.PAGE_CARTOGRAPHIE_COMPETENCES_PERSO:
            modPassName =
                                Constants.MODULE_NEOPASS_FORM_COMPETENCES_PERSONNELLES;
            break;

          case Constants.PAGE_CARTOGRAPHIE_COMPETENCES_SOCIO_PRO:
            modPassName =
                                Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO;
            break;

          case Constants.PAGE_CARTOGRAPHIE_COMPETENCES_PRO:
            modPassName =
                                Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES;
            break;
          case Constants.PAGE_CARTOGRAPHIE_COMPETENCES_SCOLAIRES:
            modPassName =
                                Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES;
            break;
          default:
            break;
          }
          let pages = list.filter((m) => m.name == modPassName)[0]
            .pages;

          var list = response.data;
          let list_mod = [];

          let list_pages = [];
          let id_pass = context.getters.infosPass.id_pass;

          pages.forEach(function (page, index_page, list_p) {
            if (
              store.getters[
                'auth/permissionsOnBeneficiariesNeopass'
              ][id_pass].includes(page.name + '_read') ||
                            store.getters[
                              'auth/permissionsOnBeneficiariesNeopass'
                            ][id_pass].includes(page.name + '_edit')
            ) {
              list_pages.push(page);
            }
          });

          let infos = {
            id_page: page_selected.id,
            libelle_page: page_selected.libelle,
            name_page: page_selected.name,
            pages: list_pages,
          };

          context.commit('SET_INFOSPAGE', infos);
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async load_evaluations(context) {
      console.log('wait...load_evaluations');
      await axios
        .get(
          '/api/cartographieIndividual/evaluations/' +
                        context.getters.infosPass.id_pass
        )
        .then((response) => {
          let datas = response.data;

          if (datas[0] && Object.keys(datas[0]).length > 0) {
            context.commit('SET_NEOPASSDATAS', datas[0]);
          } else {
            context.commit('SET_NEOPASSDATAS', {});
          }

          if (datas[1] && Object.keys(datas[1]).length > 0) {
            context.commit('SET_LISTEVALUATIONS', datas[1]);
          } else {
            context.commit('SET_LISTEVALUATIONS', {});
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async first_load_page(context, id) {
      await context.dispatch('loadModulesPages', id);
      await context.dispatch('load_infos_pass', id);
    },

    async change_page(context, infos_page) {
      await context.dispatch('update_infos_page', infos_page);
      await context.dispatch('load_evaluations');
    },
  }
};
